import React, { Fragment, useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { Button, LazyImage } from "components"
import KfPinCodeModal from "./KfPinCodeModal"
import classes from "./KfLogo.module.scss"

const KfLogo = () => {
  const history = useHistory()

  const [t, i18n] = useTranslation()

  const [openPinModal, setOpenPinModal] = useState(false)

  const systemSettings =
    useSelector(state => state.systemSettings)

  const cashierPin =
    useSelector(state =>
      state.userAccountInfo.cashierPin
    )

  const timeout = useRef()

  const handleGoBack = () => {
    history.push("/kiosk-languages")
  }

  const handlePinModalClose = () => {
    const defaultLanguage =
      localStorage.getItem("defaultLanguage") || "fa"

    i18n.changeLanguage(defaultLanguage)

    setOpenPinModal(false)
  }

  const handleSetTimer = () => {
    timeout.current =
      setTimeout(() => {
        i18n.changeLanguage("fa")

        !!cashierPin
          ? setOpenPinModal(true)
          : history.push("/kiosk-settings")
      }, 2000)
  }

  useEffect(() => {
    return () => clearTimeout(timeout.current)
  }, [])

  return (
    <Fragment>
      <div
        className={classes["container"]}
        onMouseDown={handleSetTimer}
        onTouchStart={handleSetTimer}
        onTouchEnd={() => clearTimeout(timeout.current)}
        onMouseUp={() => clearTimeout(timeout.current)}
      >
        <LazyImage
          src={systemSettings.kitchenLogo}
          imageWidth={100}
          quality={80}
          className={classes["image"]}
          alt={systemSettings.kitchenTitle}
        />

        <Button
          color="secondary"
          onClick={handleGoBack}
        >
          {t("بازگشت_به_صفحه_ی_اصلی")}
        </Button>
      </div>

      <KfPinCodeModal
        code={cashierPin}
        open={openPinModal}
        onClose={handlePinModalClose}
        onSuccess={() => history.push("/kiosk-settings")}
      />
    </Fragment>
  )
}

export default KfLogo